<div class="row">
    <div [ngClass]="isEdit || isAddNew ? 'col-sm-6' : 'col-sm-10'" *ngIf="viewType != 'customs-exceptions'">
        <kendo-grid #checkCallGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [sortable]="true"
                    [pageable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action" *ngIf="readonly != true && viewType != 'order-tracking'" width="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *showRolesIf="'Account Manager,Carrier Sales Rep,Track and Trace'">
                        <button type="button" (click)="delete(dataItem)" class="btn btn-danger m-1" title="Delete" tabindex="-1"><i class="fas fa-times"></i></button>
                        <!--<button type="button" (click)="sendCheckCallEmail(dataItem)" class="btn btn-secondary m-1" *ngIf="!isNew" tabindex="-1">Email</button>-->
                        <button type="button" (click)="getCustomerAndSendEmail(dataItem)" class="btn btn-secondary m-1" *ngIf="!isNew" tabindex="-1">Email</button>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="legNumber" title="Load #" width="100" *ngIf="quoteOrderLineID == 0"></kendo-grid-column>
            <kendo-grid-column field="eventCode" title="Event" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="isDisplayEventDescription">{{dataItem.reportDescription}}</span>
                    <span *ngIf="!isDisplayEventDescription">{{dataItem.eventCode}}</span>
                </ng-template>
            </kendo-grid-column>
            <!--<kendo-grid-column field="reportDescription" title="Description" width="150"></kendo-grid-column>-->
            <kendo-grid-column field="dateOfCall" title="Last Update" width="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.dateOfCall| date: 'M/dd/yyyy HH:mm'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="cityName" title="Location" width="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.cityID == null || dataItem.cityID < 1 ? '' : dataItem.cityName + ', ' + dataItem.stAbbr + ' ' + dataItem.zip}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="createdByEmployeeName" title="Created By" width="200" *ngIf="viewType != 'order-tracking'"></kendo-grid-column>
            <kendo-grid-column field="checkCallNote" title="Check Call Notes" *ngIf="viewType != 'order-tracking'"></kendo-grid-column>
            <kendo-grid-column field="comment" title="System Notes" *ngIf="viewType != 'order-tracking'"></kendo-grid-column>
            <kendo-grid-column title="Data Detail">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span (click)="viewCheckCallData(dataItem)" class="text-primary h4" *ngIf="dataItem.checkCallData != '' && dataItem.checkCallData != null" tabindex="-1"><i class="fas fa-eye"></i></span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div [ngClass]="isEdit || isAddNew ? 'col-sm-6' : 'col-sm-10'" *ngIf="viewType == 'customs-exceptions'">
        <kendo-grid #checkCallGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [sortable]="true"
                    [pageable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action" *ngIf="readonly != true" width="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *showRolesIf="'Account Manager,Carrier Sales Rep,Track and Trace'">
                        <button type="button" (click)="delete(dataItem)" class="btn btn-danger m-1" title="Delete" tabindex="-1"><i class="fas fa-times"></i></button>
                        <button type="button" (click)="getCustomerAndSendEmail(dataItem)" class="btn btn-warning m-1" *ngIf="!isNew" tabindex="-1">ESC</button>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="dateOfCall" title="Last Update" width="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.dateOfCall| date: 'M/dd/yyyy HH:mm'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="comment" title="System Notes"></kendo-grid-column>
            <kendo-grid-column field="checkCallNote" title="Check Call Notes"></kendo-grid-column>
            <kendo-grid-column field="cityName" title="Location" width="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.cityID == null || dataItem.cityID < 1 ? '' : dataItem.cityName + ', ' + dataItem.stAbbr + ' ' + dataItem.zip}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="eventCode" title="Event" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{getEventName(dataItem.eventCode)}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="createdByEmployeeName" title="Created By" width="200"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1">
        <div *showRolesIf="'Account Manager,Carrier Sales Rep,Track and Trace'">
            <button class="btn btn-sm btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="readonly!=true"><i class="fas fa-plus"></i></button>
        </div>
        <div style="margin-top:10px" *ngIf="viewType != 'customs-exceptions'">
            <div>
                <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                       id="isExcludeMP" name="isExcludeMP"
                       [checked]="isExcludeMP"
                       (change)="toggleIsExcludeMP()" />
                <label style="cursor:pointer" for="isExcludeMP">Exclude MP</label>
            </div>
            <div *ngIf="viewType != 'order-tracking'">
                <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                       id="isExcludeRESET" name="isExcludeRESET"
                       [checked]="isExcludeRESET"
                       (change)="toggleIsExcludeRESET()" />
                <label style="cursor:pointer" for="isExcludeRESET">Exclude Reset</label>
            </div>
        </div>
    </div>
    <div class="col" *ngIf="isAddNew || isEdit">
        <check-call-form [checkCallID]="checkCallID" [quoteOrderID]="quoteOrderID" [quoteOrderLineID]="quoteOrderLineID" [viewType]="viewType" (onRefresh)="getCheckCalls()"></check-call-form>
    </div>
</div>
<div class="row" *ngIf="isCheckCallData && !isAddNew && !isEdit">
    <div class="col">
        <kendo-grid [kendoGridBinding]="checkCallData"
                    [pageSize]="10"
                    [skip]="0"
                    [sortable]="true"
                    [filterable]="true"
                    [pageable]="true">
        </kendo-grid>
    </div>
    <div class="col-sm-1">
        <button class="btn btn-sm btn-danger" title="Close" tabindex="-1" (click)="closeCheckCallData()"><i class="fas fa-times"></i></button>
    </div>
</div>
